import styled from "styled-components";
import { SmallPrint } from "../../../styles/typography/SmallPrint.styled";
import { Error } from "./Error.styled";

export const Radios = styled.div`
  ${SmallPrint}:first-child {
    margin-bottom: 16px;
  }
  ${Error} {
    margin-top: 8px;
  }
`;
